
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 84 84"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M60 50c0 22.837-35 22.495-35 0 5.568 1.396 29.432 1.396 35 0zm-3-21c4.418 0 8 3.227 8 7.208 0 3.981-3.582 2.537-8 2.537s-8 1.444-8-2.537C49 32.228 52.582 29 57 29zm-30 0c4.418 0 8 3.227 8 7.208 0 3.981-3.582 2.537-8 2.537s-8 1.444-8-2.537C19 32.228 22.582 29 27 29zm15 55c23.196 0 42-18.804 42-42S65.196 0 42 0 0 18.804 0 42s18.804 42 42 42z"}})])
          )
        }
      }
    